import { combineReducers, configureStore, Action } from "@reduxjs/toolkit";
import authSlice from "./auth.tsx";
import { RootState } from "./types.tsx";
import exampleSlice from "./example.tsx";
import searchFieldSlice from "./search/searchField.tsx";
import conversationSlice from "./conversation.tsx";
import economicReducer from "./economic.tsx";
import intempusReducer from "./intempus.tsx";
import fenerumReducer from "./fenerum.tsx";
import notificationsReducer from "./notifications.tsx";
import featureFlagsReducer from "./featureFlags.tsx";
import { setStore, subscribeToTokenChanges } from "../utils/axios.tsx";

// Combine all reducers
const appReducer = combineReducers({
  authState: authSlice,
  exampleState: exampleSlice,
  searchFieldState: searchFieldSlice,
  conversationState: conversationSlice,
  economic: economicReducer,
  intempus: intempusReducer,
  fenerum: fenerumReducer,
  notifications: notificationsReducer,
  featureFlags: featureFlagsReducer,
});

// Create a root reducer that handles the reset action
const rootReducer = (state: RootState | undefined, action: Action) => {
  if (action.type === "RESET_STATE") {
    // Reset the entire state by returning the initial state
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

// Configure the store with the root reducer
const store = configureStore({
  reducer: rootReducer,
});

// Set the store in axios.tsx dynamically
setStore(store);
subscribeToTokenChanges(store);

export default store;
